const headerNavMenu = document.querySelector('.header-nav-menu');

class MegaMenu {
  constructor() {
    this.menu = document.querySelector('.mega-menu');
    this.hamburger = document.querySelector('.hamburger-button');
    this.closeButton = document.querySelector('.mega-menu__close');
    this.backButtons = document.querySelectorAll('.mega-menu__back-button');
    this.menuLinks = document.querySelectorAll('.mega-menu__link');
    
    this.init();
  }

  init() {
    // Hamburger toggle
    this.hamburger?.addEventListener('click', () => {
      this.menu.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });

    // Close button - updated to close all dropdowns
    this.closeButton?.addEventListener('click', () => {
      this.menu.classList.remove('is-active');
      document.body.style.overflow = '';
      // Add this line to close all dropdowns
      this.menu.querySelectorAll('.mega-menu__dropdown').forEach(dropdown => {
        dropdown.classList.remove('is-active');
      });
    });

    // Menu links (mobile)
    this.menuLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        if (window.innerWidth <= 980) {
          const parentItem = link.closest('.mega-menu__item');
          const dropdown = parentItem?.querySelector('.mega-menu__dropdown');
          
          if (dropdown) {
            e.preventDefault();
            dropdown.classList.add('is-active');
          }
        }
      });
    });

    // Back buttons
    this.backButtons.forEach(button => {
      button.addEventListener('click', () => {
        button.closest('.mega-menu__dropdown').classList.remove('is-active');
      });
    });

    // Close menu on click outside (mobile)
    document.addEventListener('click', (e) => {
      if (window.innerWidth <= 980 && 
          !this.menu.contains(e.target) && 
          !this.hamburger.contains(e.target)) {
        this.menu.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }
}

// Initialize the mega menu
document.addEventListener('DOMContentLoaded', () => {
  new MegaMenu();
});

function updateDropdownWidths() {
  const dropdowns = document.querySelectorAll('.mega-menu__dropdown:not(:has(.mega-menu__featured))');
  
  dropdowns.forEach(dropdown => {
    const level2 = dropdown.querySelector('.mega-menu__level-2');
    if (level2) {
      const childCount = level2.children.length;
      dropdown.style.setProperty('--column-count', childCount);
    }
  });
}

// Call this after your menu is initialized
//updateDropdownWidths();